// Construit l'objet scopeNav (menu de thématiques du header) à partir des données
// du dashboard. Logique MIROIR de l'effet « Sync scope nav to header store » dans
// ScopeLanding/index.jsx — garder les deux en phase si la règle d'affichage évolue.
//
// Retourne null si aucune thématique visible (équivalent du clearScopeNav).
export function buildScopeNav({
    allScopes = [],
    selectedScopes = [],
    scopeOrder = [],
    sharedThematiques = [],
    hiddenSharedScopes = [],
    isCompte = true,
    currentScope = null,
} = {}) {
    const sortScopes = (scopes) => {
        if (!scopeOrder.length) return scopes;
        return [...scopes].sort((a, b) => {
            const ia = scopeOrder.indexOf(a.slug);
            const ib = scopeOrder.indexOf(b.slug);
            if (ia === -1 && ib === -1) return 0;
            if (ia === -1) return 1;
            if (ib === -1) return -1;
            return ia - ib;
        });
    };

    const hubScope = allScopes.find(s => s.slug === 'mes-thematiques');
    const standardScopes = allScopes.filter(s =>
        s.slug !== 'mes-thematiques' && s.slug !== 'thematique-personnalisable'
        && (s.content_source || 'editorial') !== 'user'
    );
    const filtered = selectedScopes.length > 0
        ? sortScopes(standardScopes.filter(s => selectedScopes.includes(s.slug)))
        : (isCompte ? [] : sortScopes(standardScopes));

    const filteredSlugs = new Set(filtered.map(s => s.slug));
    const hubImage = hubScope?.image || null;
    const sharedScopes = (sharedThematiques || [])
        .filter(st => st.has_access && !filteredSlugs.has(st.slug) && !hiddenSharedScopes.includes(st.slug))
        .map(st => ({
            ...st,
            scope_id: st.scope_id,
            is_shared: true,
            label: st.label.replace(/^Ma Thematique — /, ''),
            image: st.image || hubImage,
        }));

    // Trier l'ensemble (éditoriales + partagées) par scopeOrder pour que les
    // partagées s'intercalent à leur position choisie (et pas collées à la fin).
    const ordered = sortScopes([...filtered, ...sharedScopes]);
    const visibleScopes = hubScope ? [hubScope, ...ordered] : ordered;
    const hasMore = standardScopes.length > filtered.length;
    if (visibleScopes.length === 0) return null;
    // noneSelected : aucune thématique éditoriale choisie (ex. arrivée depuis Google)
    // → le bouton (+) du header devient « Parcourir les thématiques ».
    return { scopes: visibleScopes, currentScope, isCompte, hasMore: hasMore || isCompte, noneSelected: filtered.length === 0 };
}
